import React from "react";
import { TableRow, TableCell, Skeleton } from "@mui/material";

interface LoadingRowProps {
  columns: number;
}

export default (props: LoadingRowProps) => (
  <TableRow
    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
  >
    {([...Array(props.columns).keys()]).map((i) => (
      <TableCell key={i}>
        <Skeleton height={32} animation="wave" />
      </TableCell>
    ))}
  </TableRow>
)